import { render, staticRenderFns } from "./selectStore.vue?vue&type=template&id=35b076b2&scoped=true&"
import script from "./selectStore.vue?vue&type=script&lang=ts&"
export * from "./selectStore.vue?vue&type=script&lang=ts&"
import style0 from "./selectStore.vue?vue&type=style&index=0&id=35b076b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b076b2",
  null
  
)

export default component.exports